import { render, staticRenderFns } from "./BattlesReel.vue?vue&type=template&id=7a3c595e&scoped=true"
import script from "./BattlesReel.vue?vue&type=script&lang=js"
export * from "./BattlesReel.vue?vue&type=script&lang=js"
import style0 from "./BattlesReel.vue?vue&type=style&index=0&id=7a3c595e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c595e",
  null
  
)

export default component.exports